module.exports = __webpack_public_path__ + "static/img/icon-invoice-action.29242ef.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/icon-invoice-action.svg
// module id = 153
// module chunks = 1